export default {
  async addProject(context, payload) {
    const data = {
      projectId: new Date().toISOString(),
      projectName: payload.projectName,
      description: payload.desc,
      tags: payload.projectType,
      date: payload.date,
      mode: payload.projectMode,
    };
    const token = context.rootGetters["auth/token"];
    const response = await fetch(
      `https://pmsystem-34a73-default-rtdb.firebaseio.com/projects.json?auth=` +
        token,
      {
        method: "POST",
        body: JSON.stringify(data),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(
        responseData.message || "Failed to save project. Please try again."
      );
      throw error;
    }

    const localData = {
      projectId: responseData.name,
      projectName: payload.projectName,
      description: payload.desc,
      tags: payload.projectType,
      date: payload.date,
      mode: payload.projectMode,
    };

    context.commit("addProject", localData);
  },

  async setProjects(context) {
    if (!context.getters.shouldUpdate) {
      return;
    }
    const token = context.rootGetters["auth/token"];
    const response = await fetch(
      `https://pmsystem-34a73-default-rtdb.firebaseio.com/projects.json?auth=` +
        token
    );
    const responseData = await response.json();
    if (!response.ok) {
      const error = new Error(
        responseData.message || "Failed to load Projects List"
      );
      throw error;
    }
    const projects = [];
    for (const key in responseData) {
      const data = {
        projectId: key,
        projectName: responseData[key].projectName,
        description: responseData[key].description,
        type: responseData[key].tags,
        date: responseData[key].date,
        mode: responseData[key].mode,
      };
      projects.push(data);
    }
    context.commit("setProjects", projects);
    context.commit("setLastTimeStamp");
  },
};
